import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "react-select";
import Model from "../Model";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  gCouncilList,
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
} from "../../Config";

const AddSubAdminModel = ({
  SingleEntryLoading,
  postAddUser,
  setOpenUploadModel,
}) => {
  const [uploadFile, setUploadFile] = useState("");
  const [districtsList, setDistricts] = useState([]);
  const { t, i18n } = useTranslation();
  const [regionLabel, setRegionLabel] = useState("");
  const [region, setRegion] = useState("");
  const InitialValues = {
    region: "",
    regionLabel: "",
  };

  const SubmitHandler = (values) => {
    console.log(values);
    if (!values.region) {
      toast.error("Please enter a region.");
      return;
    }

    postAddUser(values);
  };

  const Roles = [
    { value: "1", label: "Registrar" },
    { value: "2", label: "Customers" },
    { value: "3", label: "Subadmins" },
    { value: "4", label: "Reports" },
    // { value: "Administrator", label: "Administrator" },
  ];
  const RegistrationList = gTypeOfRegistration.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  const RegionList = gRegionsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Region</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              {/* <CombineInputGroup> */}
              <InputGroup>
                <Label htmlFor="region">Region Name</Label>
                <FieldWrapper>
                  <Field
                    name="region"
                    id="region"
                    autoComplete="off"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;

export default AddSubAdminModel;
